"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const NameTreeNode_1 = require("../../lib/tree/treeNodes/NameTreeNode");
class RectangleNameTreeNode extends NameTreeNode_1.NameTreeNode {
    constructor() {
        super(...arguments);
        this.standardColor = "black"; //"#FFF6F6";
        this.color = this.standardColor;
    }
    setColor(color) {
        this.color = color;
    }
    getColor() {
        return this.color;
    }
    resetColor() {
        this.color = this.standardColor;
    }
    keyBoardEvent() { }
    inPerimeter(coordinate, grid) {
        let myCoord = grid.getCoordinate(this);
        if (coordinate[0] >= myCoord[0] &&
            coordinate[0] <= myCoord[0] + 2 * grid.getNodeWidth()) {
            if (coordinate[1] >= myCoord[1]
                && coordinate[1] <= myCoord[1] + 2 * grid.getNodeHeight()) {
                return true;
            }
        }
        return false;
    }
    draw(ctx, grid) {
        let myCoord = grid.getCoordinate(this);
        let width = grid.getNodeWidth();
        let height = grid.getNodeHeight();
        ctx.beginPath();
        ctx.strokeStyle = this.color;
        ctx.fillStyle = "white";
        ctx.strokeRect(myCoord[1], myCoord[0], width, height);
        ctx.stroke();
        ctx.fill();
        ctx.closePath();
    }
}
exports.RectangleNameTreeNode = RectangleNameTreeNode;
